import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import Patents from '../components/Patents';

function PatentsPage() {
  return (
    <>
      <PageHero
        label="Nexus Concordat"
        title="Patents"
        subtitle="Three provisional patents protecting neurochemical AI architecture."
      />
      <BackButton />
      <Patents />
    </>
  );
}

export default PatentsPage;
